import { createContext, useContext, ReactNode } from 'react';

interface LayoutContextValue {
  /** Whether the content is inside a layout that provides padding */
  insideLayout: boolean;
}

const LayoutContext = createContext<LayoutContextValue>({ insideLayout: false });

export function LayoutProvider({ children }: { children: ReactNode }) {
  return (
    <LayoutContext.Provider value={{ insideLayout: true }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayoutContext() {
  return useContext(LayoutContext);
}
